import { createSlice } from "@reduxjs/toolkit";
import uuidv4 from "uuid/v4";
import { defaultMirrorFlyIcons } from "../../initial/iconDataSet";

const initialState = {
    "id" : uuidv4(),
    "data":defaultMirrorFlyIcons
}
const dynamicIcons = createSlice({
    name:'dynamicIcons',
    initialState,
    reducers:{
        addDynamicIcons: (_state,payload)=>{
               return {
                "id" : uuidv4(),
                "data": payload.payload
               }
        }
    }
});

export default dynamicIcons.reducer
export const addDynamicIcons = dynamicIcons.actions.addDynamicIcons